import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Employees() {
  const [employees, setEmployees]   = useState([]);
  const [pending, setPending]       = useState([]);
  const [tab, setTab]               = useState('active');
  const [showForm, setShowForm]     = useState(false);
  const [loading, setLoading]       = useState(false);
  const [form, setForm] = useState({
    full_name:'', email:'', password:'TaDa@123',
    role:'employee', department:'', joining_date:'', manager_id:''
  });
  const set = k => e => setForm(f=>({...f,[k]:e.target.value}));
  const managers = employees.filter(e => e.role === 'manager' || e.role === 'admin');

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    const [e, p] = await Promise.all([api.get('/employees'), api.get('/employees/pending')]);
    setEmployees(e.data);
    setPending(p.data);
  };

  const handleAdd = async (ev) => {
    ev.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/employees', form);
      toast.success(res.data.message);
      setShowForm(false);
      setForm({ full_name:'', email:'', password:'TaDa@123', role:'employee', department:'', joining_date:'', manager_id:'' });
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to add employee');
    } finally { setLoading(false); }
  };

  const handleApprove = async (id) => {
    try {
      await api.put(`/employees/${id}/approve`);
      toast.success('Employee approved');
      fetchData();
    } catch (err) { toast.error('Failed to approve'); }
  };

  const handleReset = async (id, name) => {
    if (!window.confirm(`Reset password for ${name} to TaDa@123?`)) return;
    try {
      await api.put(`/employees/${id}/reset-password`);
      toast.success('Password reset to TaDa@123');
    } catch (err) { toast.error('Failed to reset password'); }
  };

  const roleBadge = (r) => {
    const map = { admin:'badge-purple', manager:'badge-blue', employee:'badge-gray' };
    return <span className={`badge ${map[r]}`}>{r}</span>;
  };

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{marginBottom:0}}>Employees</h1>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ Add Employee'}
        </button>
      </div>

      {showForm && (
        <div className="card mb-16">
          <div className="card-title">Add New Employee</div>
          <form onSubmit={handleAdd}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Full Name</label>
                <input className="form-control" required value={form.full_name} onChange={set('full_name')} placeholder="Full name"/>
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input className="form-control" type="email" required value={form.email} onChange={set('email')} placeholder="Email address"/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Role</label>
                <select className="form-control" value={form.role} onChange={set('role')}>
                  <option value="employee">Employee</option>
                  <option value="manager">Manager</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Department</label>
                <input className="form-control" value={form.department} onChange={set('department')} placeholder="e.g. Sales"/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Joining Date</label>
                <input className="form-control" type="date" required value={form.joining_date} onChange={set('joining_date')}/>
              </div>
              <div className="form-group">
                <label className="form-label">Manager</label>
                <select className="form-control" value={form.manager_id} onChange={set('manager_id')}>
                  <option value="">No manager</option>
                  {managers.map(m => <option key={m.id} value={m.id}>{m.full_name}</option>)}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Default Password</label>
              <input className="form-control" value={form.password} onChange={set('password')}/>
              <small className="text-muted" style={{fontSize:11}}>Employee should change this on first login</small>
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Adding...' : 'Add Employee'}
            </button>
          </form>
        </div>
      )}

      <div className="flex gap-8 mb-16">
        <button className={`btn ${tab==='active'?'btn-primary':'btn-outline'}`} onClick={() => setTab('active')}>
          Active ({employees.filter(e=>e.is_active).length})
        </button>
        <button className={`btn ${tab==='pending'?'btn-primary':'btn-outline'}`} onClick={() => setTab('pending')}>
          Pending Approval {pending.length > 0 && <span style={{background:'var(--danger)',color:'white',borderRadius:'50%',padding:'1px 6px',fontSize:11,marginLeft:4}}>{pending.length}</span>}
        </button>
      </div>

      {tab === 'active' && (
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Department</th><th>Manager</th><th>Joined</th><th>Actions</th></tr></thead>
              <tbody>
                {employees.filter(e=>e.is_active).map(e => (
                  <tr key={e.id}>
                    <td style={{fontWeight:500}}>{e.full_name}</td>
                    <td>{e.email}</td>
                    <td>{roleBadge(e.role)}</td>
                    <td>{e.department||'—'}</td>
                    <td>{e.manager_name||'—'}</td>
                    <td>{new Date(e.joining_date).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}</td>
                    <td>
                      <button className="btn btn-outline btn-sm" onClick={() => handleReset(e.id, e.full_name)}>
                        Reset Password
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'pending' && (
        <div className="card">
          {pending.length === 0 ? (
            <div className="empty-state"><div className="icon">✅</div><p>No pending registrations</p></div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead><tr><th>Name</th><th>Email</th><th>Department</th><th>Registered On</th><th>Action</th></tr></thead>
                <tbody>
                  {pending.map(p => (
                    <tr key={p.id}>
                      <td style={{fontWeight:500}}>{p.full_name}</td>
                      <td>{p.email}</td>
                      <td>{p.department||'—'}</td>
                      <td>{new Date(p.created_at).toLocaleDateString('en-IN')}</td>
                      <td>
                        <button className="btn btn-success btn-sm" onClick={() => handleApprove(p.id)}>
                          Approve
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
